import { render, staticRenderFns } from "./SendemailModule.vue?vue&type=template&id=551b8a53"
import script from "./SendemailModule.vue?vue&type=script&lang=js"
export * from "./SendemailModule.vue?vue&type=script&lang=js"
import style0 from "./SendemailModule.vue?vue&type=style&index=0&id=551b8a53&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports